export enum FloatingFilterType {
  Chip = 'chip',
  Image = 'image'
}

export enum FloatingFilterSize {
  RG = 'rg',
  LG = 'lg'
}

export enum FloatingFilterState {
  Default = 'default',
  Active = 'active',
}
